import { toastError, toastSuccess } from '@components/Toast';

import ApiClient from '@lib/apiClient';

import { printApiError } from '@utils/Util';

import { BASE_URL } from '@/constants/constant';

export const fetchWorkflowConfiguration = async () => {
	try {
		const { data } = await ApiClient.GET('getCRMWorkflowConfiguration');
		return data;
	} catch (error) {
		toastError(error.message);
	}
};

export const fetchCRMWorkflowMembers = async () => {
	try {
		const { data } = await ApiClient.GET('getCRMWorkflowMembers');
		return data;
	} catch (error) {
		toastError(error.message);
	}
};

export const fetchTargetTeamMemberList = async (params) => {
	try {
		const { data } = await ApiClient.GET('targetTeamMemberList', params);
		return data;
	} catch (error) {
		toastError(error.message);
	}
};

export const fetchCRMRegions = async () => {
	try {
		const { data } = await ApiClient.GET('getBrandApprovalChannel');
		return data;
	} catch (error) {
		toastError(error.message);
	}
};

export const fetchCRMAllQuarters = async () => {
	try {
		const { data } = await ApiClient.GET('CRMQuartersAction');
		return data;
	} catch (error) {
		toastError(error.message);
	}
};

export const fetchCRMTargetedYears = async (params) => {
	try {
		const { data } = await ApiClient.GET('getCRMTargetedYears', params);
		return data;
	} catch (error) {
		toastError(error.message);
	}
};

export const saveTarget = async (postData) => {
	try {
		const { data } = await ApiClient.POST('saveTarget', postData);
		return data;
	} catch (error) {
		if (error?.response?.data?.message) {
			toastError(error.response.data.message);
		} else {
			toastError('Something went wrong! Please try again.');
		}
		throw error;
	}
};

export const sendTarget = async (postData) => {
	try {
		const { data } = await ApiClient.POST('sendCRMTarget', postData);
		return data;
	} catch (error) {
		if (error?.response?.data?.message) {
			toastError(error.response.data.message);
		} else {
			toastError('Something went wrong! Please try again.');
		}
		throw error;
	}
};

export const fetchCRMTargetList = async (params) => {
	try {
		const { data } = await ApiClient.GET('getCRMTarget', params);
		return data;
	} catch (error) {
		toastError(error.message);
	}
};

export const fetchCRMTargetById = async (targetId, params = '') => {
	try {
		const { data } = await ApiClient.GET(`${BASE_URL}/target/${targetId}/quarter`, params, true);
		return data;
	} catch (error) {
		toastError(error.message);
	}
};

export const updateTarget = async (postData, targetId) => {
	try {
		const { data } = await ApiClient.PUT('saveTarget', postData, `/${targetId}`);
		return data;
	} catch (error) {
		if (error?.response?.data?.message) {
			toastError(error.response.data.message);
		} else {
			toastError('Something went wrong! Please try again.');
		}
	}
};

export const getRemainingTarget = async (yearId) => {
	try {
		const { data } = await ApiClient.GET(`${BASE_URL}/target/${yearId}/remaining`, '', true);
		return data;
	} catch (error) {
		toastError(error.message);
	}
};

export const getRemainingSummary = async (params) => {
	try {
		const { data } = await ApiClient.GET('getCRMTargetSummary', params);
		return data;
	} catch (error) {
		toastError(error.message);
	}
};

export const fetchAllBrandsList = async (id) => {
	try {
		const { data } = await ApiClient.GET(`${BASE_URL}/target/${id}/available-brands`, '', true);
		return data;
	} catch (error) {
		const errorData = error.response.data;
		if (errorData.error) {
			toastError(errorData.error);
		} else {
			toastError('Something went wrong! Please try again.');
		}
		throw error;
	}
};

export const fetchAllBuyerList = async (brandId) => {
	try {
		const { data } = await ApiClient.GET(
			`${BASE_URL}/user/find-list-by-email-and-user-type?brandId=${brandId}`,
			'',
			true
		);
		return data;
	} catch ({ error }) {
		if (error.message) {
			toastError(error.message);
		} else {
			toastError('Something went wrong! Please try again.');
		}
		throw error;
	}
};

export const setProjection = async (postData) => {
	try {
		const { data } = await ApiClient.POST('setProjection', postData);
		toastSuccess(data.message);
	} catch ({ error }) {
		if (error.message) {
			toastError(error.message);
		} else {
			toastError('Something went wrong! Please try again.');
		}
		throw error;
	}
};
export const getCRMBrandWiseMonthlyProjection = async (params) => {
	try {
		const { data } = await ApiClient.GET('getCRMBrandWiseMonthlyProjection', params);
		return data;
	} catch (error) {
		toastError(error.message);
	}
};

export const getCrmWeeklylyProjection = async (params) => {
	try {
		const { data } = await ApiClient.GET('getCrmWeeklylyProjection', params);
		return data;
	} catch (error) {
		toastError(error.message);
	}
};

export const sendProjection = async (postData) => {
	try {
		const { data } = await ApiClient.POST('sendProjection', postData);
		toastSuccess(data.message);
	} catch (error) {
		if (error?.response?.data?.message) {
			toastError(error.response.data.message);
		} else {
			toastError('Something went wrong! Please try again.');
		}
		throw error;
	}
};

export const updateApprovalStatus = async (postData) => {
	try {
		const { data } = await ApiClient.POST('updateApprovalStatus', postData);
		return data;
	} catch ({ error }) {
		if (error.message) {
			toastError(error.message);
		} else {
			toastError('Something went wrong! Please try again.');
		}
		throw error;
	}
};

export const sendProjectionReview = async (postData) => {
	try {
		const { data } = await ApiClient.POST('sendApprovalStatus', postData);
		toastSuccess(data.message);
	} catch (error) {
		if (error?.response?.data?.message) {
			toastError(error.response.data.message);
		} else {
			toastError('Something went wrong! Please try again.');
		}
		throw error;
	}
};

export const getCrmMyTargetedYears = async (params) => {
	try {
		const { data } = await ApiClient.GET('getMyTargetedTears', params);
		return data;
	} catch (error) {
		toastError(error.message);
	}
};

export const getCrmBannerInfo = async (params) => {
	try {
		const { data } = await ApiClient.GET('getBannerInfos', params);
		return data;
	} catch (error) {
		toastError(error.message);
	}
};

export const getCrmTargetById = async (id) => {
	try {
		const { data } = await ApiClient.GET('getCRMTargetById', id);
		return data;
	} catch (error) {
		toastError(error.message);
	}
};

export const fetchCRMQuarterList = async () => {
	try {
		const { data } = await ApiClient.GET('getCRMQuarterList');
		return data;
	} catch (error) {
		toastError(error.message);
	}
};

export const quarterAction = async (postData) => {
	try {
		let url;
		if (postData?.id) {
			url = await ApiClient.PUT('CRMQuartersAction', postData);
		} else {
			url = await ApiClient.POST('CRMQuartersAction', postData);
		}
		const { data } = url;
		return data;
	} catch (error) {
		if (error?.response?.data?.message) {
			toastError(error.response.data.message);
		} else {
			toastError('Something went wrong! Please try again.');
		}
		throw error;
	}
};

export const getQuarterData = async (id) => {
	try {
		const { data } = await ApiClient.GET('CRMQuartersAction', `/${id}`);
		return data;
	} catch (error) {
		if (error?.response?.data?.message) {
			toastError(error.response.data.message);
		} else {
			toastError('Something went wrong! Please try again.');
		}
		throw error;
	}
};

export const removeCrmConfiguration = async (id) => {
	try {
		const { data } = await ApiClient.DELETE('CRMQuartersAction', {}, `/${id}`);
		toastSuccess(data.message);
		return data;
	} catch (error) {
		printApiError(error);
		throw error;
	}
};

export const findAllSalesFunnel = async (params) => {
	try {
		const { data } = await ApiClient.GET('salesFunnel', params);
		return data;
	} catch (error) {
		printApiError(error);
	}
};

export const findGroupWiseCounts = async (params) => {
	try {
		const { data } = await ApiClient.GET('groupWiseSalesFunnelCounts', params);
		return data;
	} catch (error) {
		printApiError(error);
	}
};

export const findAllSalesFunnelRevenueSummary = async (params) => {
	try {
		const { data } = await ApiClient.GET('salesFunnelSummary', params);
		return data;
	} catch (error) {
		printApiError(error);
	}
};

export const closeSalesFunnelStyle = async (id, params) => {
	try {
		const { data } = await ApiClient.PATCH('closeSalesFunnelStyle', params, id, false, true);
		return data;
	} catch (error) {
		printApiError(error);
	}
};

export const updateSalesFunnelOrderDate = async (postData, styleId) => {
	try {
		const { data } = await ApiClient.PATCH('updateExpepectedOrderDate', postData, styleId);
		return data;
	} catch (error) {
		printApiError(error);
	}
};

export const setCRMTarget = async (postData) => {
	try {
		const { data } = await ApiClient.POST('addNewTarget', postData);
		return data;
	} catch (error) {
		printApiError(error);
	}
};

export const updateCRMTarget = async (id, postData) => {
	try {
		const { data } = await ApiClient.PUT('target', postData, id);
		return data;
	} catch (error) {
		printApiError(error);
	}
};

export const deleteCRMTarget = async (id) => {
	try {
		const { data } = await ApiClient.DELETE('target', {}, id);
		return data;
	} catch (error) {
		printApiError(error);
	}
};

export const getCRMCountryWiseSummary = async (params) => {
	try {
		const { data } = await ApiClient.GET('countryWiseSummary', params);
		return data;
	} catch (error) {
		toastError(error.message);
	}
};

export const getCRMYearWiseSummary = async (params) => {
	try {
		const { data } = await ApiClient.GET('yearWiseSummary', params);
		return data;
	} catch (error) {
		toastError(error.message);
	}
};

export const getCRMTargetYears = async (params) => {
	try {
		const { data } = await ApiClient.GET('targetYears', params);
		return data;
	} catch (error) {
		toastError(error.message);
	}
};

export const getCRMDashboardSummary = async (params) => {
	try {
		const { data } = await ApiClient.GET('CRMDashboardSummary', params);
		return data;
	} catch (error) {
		toastError(error.message);
	}
};

export const getCRMOverallPerformance = async (params) => {
	try {
		const { data } = await ApiClient.GET('CRMOverallPerformance', params);
		return data;
	} catch (error) {
		toastError(error.message);
	}
};

export const getCRMBrandWisePerformance = async (params) => {
	try {
		const { data } = await ApiClient.GET('CRMBrandWisePerformance', params);
		return data;
	} catch (error) {
		toastError(error.message);
	}
};

export const getCRMRegionWisePerformance = async (params) => {
	try {
		const { data } = await ApiClient.GET('CRMRegionWisePerformance', params);
		return data;
	} catch (error) {
		toastError(error.message);
	}
};
export const getCRMTeamWisePerformance = async (params) => {
	try {
		const { data } = await ApiClient.GET('CRMTeamWisePerformance', params);
		return data;
	} catch (error) {
		toastError(error.message);
	}
};

export const compareCRMOverallPerformance = async (params) => {
	try {
		const { data } = await ApiClient.GET('CompareCRMOverallPerformance', params);
		return data;
	} catch (error) {
		toastError(error.message);
	}
};

export const compareCRMBrandWisePerformance = async (params) => {
	try {
		const { data } = await ApiClient.GET('CompareBrandWisePerformance', params);
		return data;
	} catch (error) {
		toastError(error.message);
	}
};

export const compareCRMRegionWisePerformance = async (params) => {
	try {
		const { data } = await ApiClient.GET('CompareRegionWisePerformance', params);
		return data;
	} catch (error) {
		toastError(error.message);
	}
};

export const compareCRMTeamWisePerformance = async (params) => {
	try {
		const { data } = await ApiClient.GET('CompareTeamWisePerformance', params);
		return data;
	} catch (error) {
		toastError(error.message);
	}
};

export const getCRMDashboardYears = async (params) => {
	try {
		const { data } = await ApiClient.GET('CRMDashboardYears', params);
		return data;
	} catch (error) {
		toastError(error.message);
	}
};

export const getCRMDashboardFilterOptions = async (params) => {
	try {
		const { data } = await ApiClient.GET('CRMDashboardFilterOptions', params);
		return data;
	} catch (error) {
		toastError(error.message);
	}
};

export const getCRMIndividualPerformance = async (params) => {
	try {
		const { data } = await ApiClient.GET('crmIndividualPerformance', params);
		return data;
	} catch (error) {
		toastError(error.message);
	}
};

//brand pricing
export const onPricingEnabled = async (id, enabled) => {
	const postData = { id, pickAndChooseEnabled: enabled };
	try {
		const { data } = await ApiClient.PUT('updateBrandInfo', postData);
		return data;
	} catch (error) {
		printApiError(error);
	}
};

export const onAddPriceRangeTableData = async (brandId, postData) => {
	try {
		const { data } = await ApiClient.POST('brandAction', postData, `${brandId}/price-range`);
		return data;
	} catch (error) {
		printApiError(error);
	}
};

export const getPriceRangeCategoryData = async (brandId, categoryId) => {
	try {
		const { data } = await ApiClient.GET('brandAction', `${brandId}/price-range/category/${categoryId}`);
		return data;
	} catch (error) {
		printApiError(error);
	}
};

export const onUpdataePriceRangeTableData = async (brandId, postData) => {
	try {
		const { data } = await ApiClient.PUT('brandAction', postData, `${brandId}/price-range`);
		return data;
	} catch (error) {
		printApiError(error);
	}
};

export const deletePriceRange = async (brandId, deletedIds) => {
	try {
		const { data } = await ApiClient.DELETE(
			'brandAction',
			{},
			`${brandId}/price-range?priceRangeIds=${deletedIds}`
		);
		return data;
	} catch (error) {
		printApiError(error);
	}
};

export const updateProfitMarginData = async (brandId, postData) => {
	try {
		const { data } = await ApiClient.POST('brandAction', postData, `${brandId}/profit-margin`);
		return data;
	} catch (error) {
		printApiError(error);
	}
};
export const closeCrmProductStyles = async (params) => {
	try {
		const { data } = await ApiClient.PATCH('closeCRMProducts', params, '', false, true);
		return data;
	} catch (error) {
		toastError(error.message);
	}
};

export const restoreCrmProductStyles = async (params) => {
	try {
		const { data } = await ApiClient.PATCH('restoreCRMProducts', params, '', false, true);
		return data;
	} catch (error) {
		toastError(error.message);
	}
};

export const addSalesFunnelEOD = async (postData) => {
	try {
		const { data } = await ApiClient.PATCH('bulkEODCRMProducts', postData);
		return data;
	} catch (error) {
		toastError(error.message);
	}
};
